module.exports = __webpack_public_path__ + "static/media/main_logo.46fac2b2.png";